/**
 * Created by tomers on 5/6/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var Page = require("ui.components/page/Page");


    var AgentGroupModel = require("user-management-models/AgentGroupModel");
    var AgentGroupEditView = require("user-management-views/agent-groups/AgentGroupEditView");
    var AgentGroupsFooterView = require("user-management-views/agent-groups/AgentGroupsFooterView");

    var UsersCollection = require("collections/entities/UsersCollection");
    var AgentGroupsMembersGridView = require("user-management-views/agent-groups/AgentGroupsMembersGridView");
    var AgentGroupsMembersGridModel = require("user-management-models/AgentGroupsMembersGridModel");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var OrganizeCollectionDecorator = require ("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var SecureUtilities = require("infra-util/SecureUtilities");
    var UserListComparators = require("user-management-comparators/UserListComparators");

    var AgentGroupEditController = {};

    var NAME_COMPARATOR = "fullName";
    var ASC_ORDERBY = "asc";
    var DEFAULT_COMPARATOR = NAME_COMPARATOR;
    var DEFAULT_ORDERBY = ASC_ORDERBY;
    var PAGE_SIZE = 50;

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        AgentGroupEditController = Marionette.Controller.extend({
            currentPagingInfo: {
                currentPageNumber: 1,
                totalPages: 1
            },
            currentComparator: DEFAULT_COMPARATOR,
            currentOrderBy: DEFAULT_ORDERBY,
            currentSelectedId: null,

            pageView: null,
            insideView: null,
            agentGroupModel: null,

            initialize: function(options) {
                this._initialize(options);
            },

            _initialize: function(options) {
                LEUserManagement.logger.info("initializing", "AgentGroupEditController:initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_EDIT);
                this.agentGroupListChannel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_LIST);
                this.profilesCollection = (LE.sessionManager.hasProfilesFeature()) ? LEUserManagement.getDataManager().getProfilesCollection() : LEUserManagement.getDataManager().getPermissionGroupsCollection();
                this._initPageView();
                this._bindEvents();
            },

            getView: function() {
                return this.pageView;
            },

            showAgentGroupEdit: function(agentGroupId) {
                this._showAgentGroupEdit(agentGroupId);
            },

            showAgentGroupAdd: function(parentGroupId) {
                this._showAgentGroupAdd(parentGroupId);
            },

            _initPageView: function(){
                LEUserManagement.logger.debug("init page view and listen to its close", "AgentGroupEditController:_initPageView");

                this.pageView = new Page({
                    moduleName: LEUserManagement.moduleName,
                    context: LE.context,
                    permutation: Page.PERMUTATION.Standard,
                    contentWidth: Page.CONTENT_WIDTH.XLarge,
                    footer: new AgentGroupsFooterView()
                });

                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _bindEvents: function() {
                this.listenTo(this.channel.vent, "agentGroup:change:name", this._onNameChange);
                this.listenTo(this.channel.vent, "agentGroup:description:change", this._onDescriptionChange);
                this.listenTo(this.channel.vent, "agentGroup:cancel", this._onCancelClick);
                this.listenTo(this.channel.vent, "agentGroup:save", this._onSaveClick);
                this.listenTo(this.channel.vent, "agentGroup:manager:add", this._onManagerAdd);
                this.listenTo(this.channel.vent, "agentGroup:manager:remove", this._onManagerRemove);
                this.listenTo(this.channel.vent, "agentGroup:member:add", this._onMemberAdd);
                this.listenTo(this.channel.vent, "agentGroup:member:remove", this._onMemberRemove);
                this.listenTo(this.channel.vent, "paging:change", this._onPagingChange);
            },

            _showAgentGroupEdit: function(agentGroupId) {
                LEUserManagement.logger.info("show AgentGroup edit view", "AgentGroupEditController:_showAgentGroupEdit", agentGroupId);
                this._fetchAgentGroup(agentGroupId);
            },

            _showAgentGroupAdd: function(parentAgentGroupId) {
                LEUserManagement.logger.info("show AgentGroup edit view", "AgentGroupEditController:_showAgentGroupEdit", parentAgentGroupId);
                this._createNewAgentGroup(parentAgentGroupId);
            },

            _createNewAgentGroup: function(parentAgentGroupId) {
                var id = parentAgentGroupId && parseInt(parentAgentGroupId, 10);
                this.agentGroupModel = new AgentGroupModel();
                this.agentGroupModel.setParentGroupId(id);
                this._showView();
            },

            _fetchAgentGroup: function(agentGroupId) {
                this.agentGroupModel = new AgentGroupModel({id:agentGroupId});
                this._showLayoutLoader();
                this.agentGroupModel.fetch({
                    success: _.bind(this._onFetchAgentGroupSuccess, this),
                    error:  _.bind(this._onFetchAgentGroupError, this)
                });
            },

            _onFetchAgentGroupSuccess: function(model, response, options) {
                LEUserManagement.logger.debug("fetch AgentGroup success", "AgentGroupEditController:_onFetchAgentGroupSuccess", response);
                this._showView();
            },

            _onFetchAgentGroupError: function(model, response, options) {
                LEUserManagement.logger.debug("fetch AgentGroup error closing loader returning to list", "AgentGroupEditController:_onFetchAgentGroupError", response);
                this._closeLayoutLoader();
                LEUserManagement.notifier.showError({content:LE.translator.translate("LEUserManagement.agentGroupEdit.errorOnFetching.text"), timeToShow: 6000});
                this._navigateToAgentGroupList();
            },

            _showView: function() {
                LEUserManagement.logger.debug("show the AgentGroup edit view in the page", "AgentGroupEditController:_showView");
                this._closeLayoutLoader();

                var title = (this.agentGroupModel.isNew()) ? LE.translator.translate("LEUserManagement.agentGroupEdit.header.title.new") : LE.translator.translate("LEUserManagement.agentGroupEdit.header.title.edit");
                this._unbindEventsDataAndViews();
                this._initMembersTableData();
                this._initViews();
                this.pageView.setTitle(title);
                this.pageView.setDescription(LE.translator.translate("LEUserManagement.agentGroupEdit.header.description"));

                this.insideView.gridRegion.show(this.agentGroupsMembersGridView);
            },

            _initMembersTableData: function() {
                var currentMembersIds = this.agentGroupModel.getMembers();
                var currentMembersModels = [];
                _.each(currentMembersIds, function(currentMemberId) {
                    var userModel = LEUserManagement.getDataManager().getUsersCollection().get(currentMemberId);
                    if (userModel) {
                        currentMembersModels.push(userModel);
                    }
                });

                var currentMembersCollection = new UsersCollection(currentMembersModels);
                currentMembersCollection = SelectableCollectionDecorator.decorate(currentMembersCollection);

                this.currentMembersCollection = OrganizeCollectionDecorator.decorate(currentMembersCollection, {
                    comparator: this.currentComparator,
                    orderBy: this.currentOrderBy,
                    currentPage: this.currentPagingInfo.currentPageNumber,
                    pageSize: PAGE_SIZE,
                    lazy: true
                });
                this.listenTo(this.currentMembersCollection ,"reset", this._onCollectionReset);
            },

            _initViews: function() {
                this.insideView = new AgentGroupEditView({
                    model: this.agentGroupModel,
                    currentMembersCollection: this.currentMembersCollection,
                    potentialMembersCollection: this.potentialMembersCollection,
                    potentialManagersCollection: this.potentialManagersCollection
                });
                this.listenTo(this.insideView, "show", this._onLayoutShown);  //listen to show not render ( we are using region add - this will trigger every time the view is seen )
                this.listenTo(this.insideView, "close", this._onLayoutClose);
                this.pageView.setInsideView(this.insideView);
                this.agentGroupsMembersGridModel = new AgentGroupsMembersGridModel();

                this.agentGroupsMembersGridView = new AgentGroupsMembersGridView({
                    collection: this.currentMembersCollection,
                    model: this.agentGroupsMembersGridModel,
                    comparators: UserListComparators
                    //filters: AgentGroupsMembersFilters
                });
            },

            //happens every time
            _onLayoutShown: function() {
                LEUserManagement.logger.debug("_onLayoutShown", "AgentGroupEditController:_onLayoutShown");
                this.currentMembersCollection.organize();
            },

            _onLayoutClose: function() {
                LEUserManagement.logger.debug("_onLayoutClose", "AgentGroupEditController:_onLayoutClose");
                this._unbindEventsDataAndViews();
            },

            _unbindEventsDataAndViews: function() {
                LEUserManagement.logger.debug("_unbindEventsDataAndViews", "AgentGroupListController:_unbindEventsDataAndViews");
                if (this.insideView) {
                    this.stopListening(this.insideView);
                }
                if (this.currentMembersCollection) {
                    this.stopListening(this.currentMembersCollection);
                    this.currentMembersCollection.unBindFromOriginalCollectionEvents();
                }
            },

            _onNameChange: function(name) {
                this.agentGroupModel.setName(name);
            },

            _onDescriptionChange: function(desc) {
                this.agentGroupModel.setDescription(desc);
            },

            _onManagerAdd: function(managerId) {
                this.agentGroupModel.addManager(managerId);
            },

            _onManagerRemove: function(managerId) {
                this.agentGroupModel.removeManager(managerId);
            },

            _onMemberAdd: function(memberId) {
                this.agentGroupModel.addMember(memberId);
            },

            _onMemberRemove: function(memberId) {
                this.agentGroupModel.removeMember(memberId);
            },

            _onCancelClick: function() {
                LEUserManagement.logger.info("cancel the AgentGroup edit", "AgentGroupEditController:_onCancelClick");
                this._navigateToAgentGroupList();
            },

            _onSaveClick: function() {
                LEUserManagement.logger.info("save the AgentGroup", "AgentGroupEditController:_onSaveClick", this.agentGroupModel);

                var newMembersArr = this._getNewMembers();
                if (newMembersArr.length > 0) {
                    this._showSaveConfirmation(newMembersArr);
                }
                else {
                    this._onSaveConfirmed();
                }
            },

            _onSaveConfirmed: function() {
                this._beforeSave();
                var needToUpdateUsers = this._needToUpdateUsers();
                this.agentGroupModel.save(null, {
                    updateUsers: needToUpdateUsers,
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },

            _onSaveSuccess: function(model, response, options) {
                LEUserManagement.logger.info("AgentGroup saved successfully", "AgentGroupEditController:_onSaveSuccess", model);
                LEUserManagement.getDataManager().updateCollection(model);

                var plannedDelayBeforeNavigation = LEUserManagement.hasEntireAgentGroupTreePrivilege() ? 0 : 5000; // TODO: Tomer: This is workaround so dataUnderAgentManager api will have time to re-build itslef before the navigation

                _.delay(_.bind(function() {
                    this._afterSave();
                    this._navigateToAgentGroupList();
                }, this), plannedDelayBeforeNavigation);
            },

            _onSaveError: function(model, resp, options) {
                LEUserManagement.logger.info("AgentGroup could not be saved", "AgentGroupEditController:_onSaveError", model);

                var errorObject = {};
                var errorMessage = LE.translator.translate("LEUserManagement.agentGroupEdit.errors.general.error");

                this._afterSave();
                if (resp && resp.responseError) {
                    if (resp.responseError.message) {
                        errorMessage = resp.responseError.message;
                    }
                    if (resp.responseError.internalCode) {
                        if (resp.responseError.internalCode === ErrorCodes.concurrentModificationConflict) {
                            errorMessage = LE.translator.translate("LEUserManagement.agentGroupEdit.errors.outdated.revision.error");
                        }
                        else if (resp.responseError.internalCode === ErrorCodes.noDataFound) {
                            errorMessage = LE.translator.translate("LEUserManagement.agentGroupEdit.errors.deleted.entity.error");
                            this._onCancel();
                        }
                        else if (resp.responseError.internalCode === ErrorCodes.uniquenessViolation) {
                            errorObject[model.KEYS.NAME] = LE.translator.translate("LEUserManagement.agentGroupEdit.errors.name.duplicate");
                        }
                    }
                }


                var messageToShow = (!_.isEmpty(errorObject)) ? LEUserManagement.getGeneralErrorMsg(errorObject) : errorMessage;
                LEUserManagement.notifier.showError({"content":messageToShow, "timeToShow":8000});
                this.channel.trigger("agentGroup:save:error", errorObject);
            },

            _onSaveInvalid: function(model, errorObject) {
                LEUserManagement.logger.info("AgentGroup could not be saved", "AgentGroupEditController:_onSaveInvalid", model);

                this._afterSave();
                var translatedErrorObj = {};
                _.each(errorObject, function (value, key) {
                    translatedErrorObj[key] = LE.translator.translate(value);
                });

                var messageToShow = LEUserManagement.getGeneralErrorMsg(translatedErrorObj);
                LEUserManagement.notifier.showError({"content":messageToShow, "timeToShow":8000});
                this.channel.trigger("agentGroup:save:error", translatedErrorObj);
            },

            _showSaveConfirmation: function(newMembersArr) {
                LEUserManagement.notifier.showConfirm({
                    title: LE.translator.translate("LEUserManagement.agentGroupEdit.member.change.group.notification.title"),
                    content: this._getSaveConfirmationMessage(newMembersArr),
                    objectAction: {
                        text: LE.translator.translate("LEFramework.global.captions.ok"),
                        callback: _.bind(this._onSaveConfirmed, this)
                    }
                });
            },

            _needToUpdateUsers: function() {
                var previousMembers = this.agentGroupModel.getPreviousMembers();
                var currentMembers = this.agentGroupModel.getMembers();
                var membersWasUpdated = this.agentGroupModel.getIsMemberChange() && (_.difference(currentMembers, previousMembers).length > 0 || _.difference(previousMembers, currentMembers).length > 0);

                var previousManagers = this.agentGroupModel.getPreviousManagers();
                var currentManagers = this.agentGroupModel.getManagers();
                var managersWasUpdated = this.agentGroupModel.getIsManagerChange() && (_.difference(currentManagers, previousManagers).length > 0 || _.difference(previousManagers, currentManagers).length > 0);

                return membersWasUpdated || managersWasUpdated;
            },

            _getNewMembers: function() {
                var newMembersIds = [];
                var newMembersArr = [];

                if (this.agentGroupModel.getIsMemberChange()) {
                    var rootGroupId = LEUserManagement.getDataManager().getAgentGroupsCollection().getMainGroup().id;
                    var previousMembers = this.agentGroupModel.getPreviousMembers();
                    var currentMembers = this.agentGroupModel.getMembers();
                    newMembersIds = _.difference(currentMembers, previousMembers);

                    _.each(newMembersIds, function(userId) {
                        var newMemberModel = LEUserManagement.getDataManager().getUsersCollection().get(userId);
                        var newMemberCurrentGroup = (newMemberModel) ? newMemberModel.getMemberOfGroup() : null;
                        if (newMemberCurrentGroup && newMemberCurrentGroup !== rootGroupId) {
                            var currentGroupName = LEUserManagement.getDataManager().getNameById(LEUserManagement.getDataManager().getEntities().AGENT_GROUP, newMemberCurrentGroup);
                            newMembersArr.push({
                                displayName: newMemberModel.getDisplayName(),
                                currentGroupName: currentGroupName
                            });
                        }
                    });
                }

                return newMembersArr;
            },

            _getSaveConfirmationMessage: function(newMembersArray) {
                var MAX_USERS_TO_SHOW = 20;
                var showAndMore = newMembersArray.length > MAX_USERS_TO_SHOW;
                var shrinkedNewMembersArray = newMembersArray.slice(0, MAX_USERS_TO_SHOW);

                var newMembersString = "<br/>";
                _.each(shrinkedNewMembersArray, function(newUser, index) {
                    newMembersString = newMembersString + (index + 1) + ". " + SecureUtilities.escapeForHtmlContent(newUser.displayName) + "  -  " +  SecureUtilities.escapeForHtmlContent(newUser.currentGroupName) + "<br/>";
                });

                if (showAndMore) {
                    var andMoreText = LE.translator.translate({
                        key: "LEUserManagement.agentGroupEdit.member.change.group.notification.andMore",
                        args: [{key: (newMembersArray.length - shrinkedNewMembersArray.length)}]
                    });
                    newMembersString = newMembersString + andMoreText;
                }

                var confirmationMessage = LE.translator.translate({
                    key: "LEUserManagement.agentGroupEdit.member.change.group.notification.message",
                    args: [
                        {key: newMembersString},
                        {key: SecureUtilities.escapeForHtmlContent(this.agentGroupModel.getName())}
                    ]
                });

                return confirmationMessage;
            },

            _beforeSave: function() {
                this._showLayoutLoader();
                this.listenTo(this.agentGroupModel, "invalid", this._onSaveInvalid);
            },

            _afterSave: function() {
                this.stopListening(this.agentGroupModel, "invalid");
                this._closeLayoutLoader();
            },


            _showLayoutLoader: function() {
                LEUserManagement.showLoader();
            },

            _closeLayoutLoader: function() {
                LEUserManagement.closeLoader();
            },

            _navigateToAgentGroupList: function() {
                LEUserManagement.logger.info("navigate to AgentGroup list", "AgentGroupEditController:_navigateToAgentGroupList");
                LEUserManagement.router.navigate("agentGroups");
                this.agentGroupListChannel.trigger("deselectModel");
            },

            _onPageClose: function() {
                LEUserManagement.logger.debug("Page component in AgentGroup edit is closed. re-init it.", "AgentGroupEditController:onPageClose");
                this._unbindEventsDataAndViews();
                this.insideView = null;
                this.stopListening(this.pageView);
                this._initPageView();
            },

            _onCollectionReset: function(collection, options) {
                //set correct comparator
                if (_.has(options, "comparator")) {
                    this.currentComparator = options.comparator;
                }

                // set correct order by
                if (_.has(options, "orderBy")) {
                    this.currentOrderBy = options.orderBy;
                }
            },

            _onPagingChange: function(currentPageNumber) {
                this.currentMembersCollection.organize({currentPage:currentPageNumber});
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return  AgentGroupEditController;
});
